import { Reveal } from "@/components/Reveal";
import { GoldDivider } from "@/components/GoldDivider";
import { useLang } from "@/i18n";

export const HowItWorks = () => {
    const { t } = useLang();
    const steps = t("how.steps");

    return (
        <section id="como-funciona" data-testid="how-it-works-section" className="relative py-24 sm:py-32 px-5 sm:px-8 bg-ink">
            <div className="max-w-6xl mx-auto">
                <Reveal className="text-center mb-16">
                    <p className="font-accent text-[11px] tracking-[0.4em] uppercase text-gold-soft mb-4">
                        {t("how.eyebrow")}
                    </p>
                    <h2 className="font-display font-semibold gold-text text-4xl sm:text-5xl tracking-wide">
                        {t("how.title")}
                    </h2>
                    <GoldDivider className="mt-8" />
                </Reveal>

                <div className="relative grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-6">
                    <div className="hidden md:block absolute top-7 left-[12%] right-[12%] h-px bg-gradient-to-r from-transparent via-gold/35 to-transparent" aria-hidden="true" />
                    {steps.map((s, i) => (
                        <Reveal key={i} delay={i * 0.1} className="relative text-center">
                            <div data-testid={`how-step-${i + 1}`} className="flex flex-col items-center">
                                <span className="relative z-10 w-14 h-14 rounded-full border border-gold/50 bg-ink flex items-center justify-center font-display text-xl text-gold shadow-[0_0_18px_rgba(212,175,55,0.18)]">
                                    {i + 1}
                                </span>
                                <h3 className="font-display text-lg font-semibold text-cream tracking-wide mt-5 mb-2.5">
                                    {s.title}
                                </h3>
                                <p className="text-sm text-cream/60 font-light leading-relaxed max-w-[15rem]">
                                    {s.desc}
                                </p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
};
